import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * hr: davomat (bugun, hisobot), xodimlar va kartochka, jadval/smenalar, ta'tillar, ish haqi,
 * bo'limlar, FaceID qurilmalar, bayramlar. Xodimning o'z kartochkasi — identity profil sahifasi
 * va W ilova (`/api/v1/hr/me*`).
 */
export const workRoutes: RouteObject[] = [
  { path: 'hr', ...page(() => import('./pages/TodayPage')) },
  { path: 'hr/employees', ...page(() => import('./pages/EmployeesPage')) },
  { path: 'hr/employees/:id', ...page(() => import('./pages/EmployeeCardPage')) },
  { path: 'hr/report', ...page(() => import('./pages/ReportPage')) },
  { path: 'hr/schedule', ...page(() => import('./pages/SchedulePage')) },
  { path: 'hr/leaves', ...page(() => import('./pages/LeavesPage')) },
  { path: 'hr/payroll', ...page(() => import('./pages/PayrollPage')) },
  { path: 'hr/structure', ...page(() => import('./pages/StructurePage')) },
  { path: 'hr/devices', ...page(() => import('./pages/DevicesPage')) },
  { path: 'hr/holidays', ...page(() => import('./pages/HolidaysPage')) },
];

export const sellerRoutes: RouteObject[] = [];
